/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.ai.rpc.AcademyAIRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './AcademyAIRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.ai.rpc.AcademyAIRpc#searchQuestions
 */
export const SEARCH_QUESTIONS_QUERY_FIELD_NAME = 'com_hubspot_academy_ai_rpc_AcademyAIRpc_searchQuestions';
export const SEARCH_QUESTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_QUESTIONS_QUERY_FIELD_NAME,
  args: ['searchTerm'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.searchQuestionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.ai.rpc.AcademyAIRpc#submitQuery
 */
export const SUBMIT_QUERY_QUERY_FIELD_NAME = 'com_hubspot_academy_ai_rpc_AcademyAIRpc_submitQuery';
export const SUBMIT_QUERY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SUBMIT_QUERY_QUERY_FIELD_NAME,
  args: ['query'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.submitQueryRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.ai.rpc.AcademyAIRpc#getQueryResult
 */
export const GET_QUERY_RESULT_QUERY_FIELD_NAME = 'com_hubspot_academy_ai_rpc_AcademyAIRpc_getQueryResult';
export const GET_QUERY_RESULT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_QUERY_RESULT_QUERY_FIELD_NAME,
  args: ['referenceId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getQueryResultRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.ai.rpc.AcademyAIRpc#removePregeneratedAnswer
 */
export const REMOVE_PREGENERATED_ANSWER_QUERY_FIELD_NAME = 'com_hubspot_academy_ai_rpc_AcademyAIRpc_removePregeneratedAnswer';
export const REMOVE_PREGENERATED_ANSWER_QUERY = /* #__PURE__ */registerQuery({
  fieldName: REMOVE_PREGENERATED_ANSWER_QUERY_FIELD_NAME,
  args: ['referenceId'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.removePregeneratedAnswerRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});